export default {
  name: "PageComponent",
};